module.exports = __webpack_public_path__ + "static/media/mc-columns-cloud-3.37dffcb4.svg";